<template lang="pug">
  div
    //- エラーメッセージ
    b-alert.text-left(v-model="errorMessages.length > 0", variant="danger")
      p.font-size-sm.message(v-for="message in errorMessages") {{message}}
</template>

<script>
export default {
  name: 'AppMessages',
  props: {
    errorMessages: {type: Array, default: function () { return [] }}
  }
}
</script>

<style scoped lang="scss">
p.message {
  margin: 0;
}
</style>
